


















import { Vue, Component } from 'vue-property-decorator';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import APIService from '@/api';

@Component({
  components: {
    FlexButton
  }
})
export default class MerchantConnect extends Vue {
  service = new APIService();

  backToTwism() {
    window.open(this.service.dashboardHost() + '/onboarding', '_blank');
  }
}
